const bussinessUsers = {
    create: () => 'create/offer',
    getById: (id) => `getOfferById/${id}`,
}
export default bussinessUsers
